import script from "./EditRoles.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditRoles.vue?vue&type=script&setup=true&lang=ts"

import "./EditRoles.vue?vue&type=style&index=0&id=7ec0b82e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/workspace/OneTegProdDeployment/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7ec0b82e"]])

export default __exports__